import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "frequently-asked-questions"
    }}>{`Frequently Asked Questions`}</h1>
    <p>{`Have a question that is not covered here? `}<a parentName="p" {...{
        "href": "https://github.com/TimboKZ/Chonky/issues"
      }}>{`Create an
issue`}</a>{` on GitHub.`}</p>
    <h2 {...{
      "id": "how-can-i-set-the-default-file-view-grid-list-and-sort-function"
    }}>{`How can I set the default file view (grid, list) and sort function?`}</h2>
    <p>{`To set the default file view or sort order, you need to pass a valid action ID to the
relevant prop on `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { ChonkyActions, FileBrowser } from 'chonky';

<FileBrowser
    files={[]}
    defaultFileViewActionId={ChonkyActions.EnableListView.id}
    defaultSortActionId={ChonkyActions.SortFilesByDate.id}
>
    {/* ... */}
</FileBrowser>;
`}</code></pre>
    <p>{`You can also set the action IDs globally:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { ChonkyActions, setChonkyDefaults } from 'chonky';

setChonkyDefaults({
    defaultFileViewActionId: ChonkyActions.EnableListView.id,
    defaultSortActionId: ChonkyActions.SortFilesByDate.id,
});
`}</code></pre>
    <p>{`Note that the actions you are using should be enabled (either by default or by you).
You can use the following default action IDs:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`ChonkyActions.EnableGridView.id;
ChonkyActions.EnableListView.id;
ChonkyActions.SortFilesByName.id;
ChonkyActions.SortFilesByDate.id;
ChonkyActions.SortFilesBySize.id;
`}</code></pre>
    <h2 {...{
      "id": "i-want-to-sort-the-file-array-myself-how-do-i-disable-chonkys-built-in-sorting"
    }}>{`I want to sort the file array myself. How do I disable Chonky's built-in sorting?`}</h2>
    <p>{`You can set the default sort action ID to `}<inlineCode parentName="p">{`null`}</inlineCode>{` as shown below. When a `}<inlineCode parentName="p">{`null`}</inlineCode>{` value is
provided, Chonky just displays the files in the order they appear in the original
`}<inlineCode parentName="p">{`files`}</inlineCode>{` array. You might also want to hide the sort buttons from the toolbar, which
can be done by passing relevant action IDs to `}<inlineCode parentName="p">{`disableDefaultFileActions`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`<FileBrowser
    files={[]}
    defaultSortActionId={null}
    disableDefaultFileActions={[
        ChonkyActions.SortFilesByName.id,
        ChonkyActions.SortFilesByDate.id,
        ChonkyActions.SortFilesBySize.id,
    ]}
>
    {/* ... */}
</FileBrowser>
`}</code></pre>
    <h2 {...{
      "id": "how-can-i-get-or-set-the-current-file-selection"
    }}>{`How can I get or set the current file selection?`}</h2>
    <p>{`You have two mechanisms available to you:`}</p>
    <ol>
      <li parentName="ol">{`You can `}<a parentName="li" {...{
          "href": "/docs/2.x/file-actions/action-handler"
        }}>{`define a custom action handler`}</a>{` and listen
for actions with the ID `}<inlineCode parentName="li">{`ChonkyActions.ChangeSelection.id`}</inlineCode>{`. This is useful when you
want to update React on every selection change.`}</li>
      <li parentName="ol">{`You can use `}<a parentName="li" {...{
          "href": "/basics/browser-handle"
        }}>{`the file browser handle`}</a>{` to get or set the selection at runtime.
This is useful when you don't need to update React state when selection changes.`}</li>
    </ol>
    <h2 {...{
      "id": "how-can-i-trigger-an-action-programmatically"
    }}>{`How can I trigger an action programmatically?`}</h2>
    <p>{`There are two ways to trigger file actions programatically:`}</p>
    <ol>
      <li parentName="ol">{`Using `}<a parentName="li" {...{
          "href": "/basics/browser-handle"
        }}>{`the file browser handle`}</a>{`.`}</li>
      <li parentName="ol">{`Using `}<a parentName="li" {...{
          "href": "/file-actions/effects"
        }}>{`file action effects`}</a>{`.`}</li>
    </ol>
    <p>{`Note that in both cases, you should be careful with the action payload. If you provide
an `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` payload to an action that expects non-null payload, Chonky might throw an
error.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      